<div class="author-action">
  <h1>{{ authorId ? "Edit" : "Add" }} New Author</h1>
  <div class="author-action__content">
    <form [formGroup]="authorForm" (submit)="onSubmit()">
      <div class="input-field author-action__name">
        <label>Author Name <span>*</span></label>
        <input
          type="text"
          formControlName="name"
          placeholder="Enter Title"
          inNoWhitespace
          maxlength="100"
          inOnlyAlphabets
        />
        <span
          *ngIf="authorForm.get('name')?.errors?.['required']&&(authorForm.get('name')?.dirty||authorForm.get('name')?.touched)"
        >
          Author name is required
        </span>
      </div>

      <div class="flex-wrap justify-between">
        <div class="author-action__form">
          <div class="input-field">
            <label>Description <span>*</span></label>
            <textarea
              inNoWhitespace
              formControlName="description"
              placeholder="Enter Description"
            ></textarea>
            <span
              *ngIf="authorForm.get('description')?.errors?.['required']&&(authorForm.get('description')?.dirty||authorForm.get('description')?.touched)"
            >
              Author description is required
            </span>
          </div>
        </div>
        <div class="author-action__upload flex-col">
          <label>Upload Profile Image <span>*</span></label>
          <div class="author-action__file flex-col align-center justify-center">
            <app-upload-image
              (uploadEnd)="onUploadEnd($event)"
              (uploadStart)="onUploadStart()"
              [previewUrl]="profileImagePreviewUrl"
              (removeImage)="removeImage()"
            ></app-upload-image>
          </div>
          <div
            class="is-error"
            *ngIf="authorForm.get('profileImage')?.errors?.['required']&&(authorForm.get('profileImage')?.dirty||authorForm.get('profileImage')?.touched)"
          >
            Profile image is required
          </div>
        </div>
      </div>

      <div class="author-action__editor">
        <label>Author Bio <span>*</span></label>
        <app-custom-editor controlName="bio" [form]="authorForm"></app-custom-editor>
        <div
          class="author-action__error"
          *ngIf="authorForm.get('bio')?.errors?.['required']&&(authorForm.get('bio')?.dirty||authorForm.get('bio')?.touched)"
        >
          Author bio is required
        </div>
      </div>
      <div class="author-action__footer flex justify-end">
        <app-button customClass="outline" (action)="cancel()" label="cancel">
        </app-button>
        <app-button
          [isDisabled]="isLoading || initialLoading || imageUploading"
          type="submit"
          label="Submit"
        >
          <app-button-loader
            *ngIf="isLoading"
            postfixContent
          ></app-button-loader>
        </app-button>
      </div>
    </form>
  </div>
</div>
